import zwitCore from "./config/http";
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
export default {
  // 会议
  getParticipateList(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeetingMember/participateList",
      params,
      false
    );
  },
  getapplicationList(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeetingMember/signUpList",
      params,
      false
    );
  },
  // 我的收藏里我的图书
  bookList(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-goods/goodsCollect/nf/getUserBookCollectList",
      params,
      false
    );
  },
  // 我的书架
  bookshelf(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-order/user/goods/nf/list",
      params,
      false
    );
  },
  // 我的课程
  getCurriculumList(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-information/articleCurriculumMember/myCurriculumList",
      params,
      false
    );
  },
  // 参会成员信息
  selectList(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleMeetingMember/select",
      params,
      false
    );
  },
  // 系统消息
  sysMessageList(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/message/nf/sysMessageList",
      params,
      false
    );
  },
  // 公告列表
  syslist(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-public/announcement/list",
      params,
      false
    );
  },
  // 公告详情
  detailList(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-public/announcement/detail",
      params,
      false
    );
  },
  // 全部标记为已读
  setAllRead(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-message/userMessage/setAllRead",
      params,
      false
    );
  },
  // 消息条数
  messageCount(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-message/userMessage/messageCount",
      params,
      false
    );
  },
  // 订单数量统计
  orderCount(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-order/order/nf/count",
      params,
      false
    );
  },
  // 用户注销接口
  postDestroy(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/user/nf/destroy",
      params,
      false
    );
  },
  // 判断是否可以注销
  postisDestroy(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/user/nf/isDestroy",
      params,
      false
    );
  },
  // vant upload 没有实现文件上传至服务器，需手动实现 （post : multipart/formdata）
  uploadFileMannual(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(BASE_URL + "/zw-public/web/common/upload", data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(
          (response) => {
            let result = response.data;
            if (result.resultCode == 200) {
              resolve(result);
            } else {
              reject(result);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  },
  /* ------------------订单相关start------------------ */
  // 订单列表
  ordersList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-order/order/nf/list",
      data,
      false
    );
  },
  // 删除子订单 /order/nf/subDel params:子订单编号
  delSubOrder(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-order/order/nf/subDel",
      params,
      false
    );
  },
  // 删除主订单
  delPrimaryOrder(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-order/order/nf/primaryDel",
      params,
      false
    );
  },
  // 取消订单（取消操作为取消主订单） /order/nf/cancel params:主订单编号
  cancelOrder(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-order/order/nf/cancel",
      params,
      false
    );
  },
  // 主订单详情 待付款查询主订单 params:paybatchId /order/nf/primaryDetail
  primaryOrderDetail(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-order/order/nf/primaryDetail",
      params,
      false
    );
  },

  // 子订单详情, /order/nf/detail params:子订单编号
  subOrderDetial(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-order/order/nf/detail",
      params,
      false
    );
  },
  // 会议订单查询报名人信息（订单详情中查询传递订单id，报名人信息传递id
  // 根据条件查询参会成员信息 /zw-information/articleMeetingMember/select
  meetingMemberInfoInOrders(params) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleMeetingMember/select",
      params,
      false
    );
  },
  // 会议订单/查看参会人/查询报名表单审核项用于回显报名人数据 zw-information/articleMeetingMember/getFormItemByGoodsId
  meetingOrderSignupsConfig(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-information/articleMeetingMember/getFormItemByGoodsId",
      params,
      false
    );
  },
  // 我的参与的会议-会议稿件详情
  queryArt(params) {
    return zwitCore.HTTP.get(
      BASE_URL + `/zw-information/articleMeeting/queryArt/${params.meetingId}/${params.memberId}`,
      params,
      false
    );
  },
  // 确认收货 /order/send/nf/receiptConfirm
  receiptConfirm(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-order/order/send/nf/receiptConfirm",
      params,
      false
    );
  },

  /* ------------------订单相关end------------------ */

  /* ------------------物流相关start----------------- */
  // 获取物流信息
  orderExpress(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-logistics/orderExpress/nf/detail",
      params,
      false
    );
  },
  // 获取物流公司
  getExpressCompanyList(params) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-logistics/expressCompany/nf/list",
      params,
      false
    );
  },
  /* ------------------物流相关end------------------ */
};
